/**
 * pages/knowledge/ask.js — «АСУУХ» — журам, заавраас хайх
 *
 * Зам: /knowledge/ask
 *
 * Ажилтан энгийн үгээр БИЧЖЭЭД эсвэл ДУУ ХООЛОЙгоор асуухад холбогдох
 * журмын заалт, ХАБ заавар, технологийн карт, чек листийн мөр, аюулын
 * хүчин зүйлийг олж өгнө.
 *
 * ⚠ ЭНЭ НЬ ХАЙЛТ, ХАРИУЛТ БИШ. «Хэдэн жилд хийх вэ» гэж асуухад систем
 *   тоог хэлэхгүй — холбогдох ЗААЛТЫГ олж өгнө. Тиймээс гарчиг нь
 *   «Холбогдож болзошгүй» гэсэн үгээр эхэлнэ — ажилтан үүнийг албан ёсны
 *   хариулт гэж ойлговол буруу үйлдэл хийж болзошгүй.
 *
 * ⚠ Дуу хоолой нь ОДОО БАЙГАА STT-г (Chimege) дахин ашиглана —
 *   `VoiceRecorder` нь `onTranscript(text)` буцаана. `onAudioUploaded`
 *   ӨГӨӨГҮЙ тул хайлтын аудио MinIO-д ХАДГАЛАГДАХГҮЙ (хэрэггүй өгөгдөл
 *   хуримтлуулахгүй).
 *
 * Backend: GET /xab/ask?q=...
 */
import React, { useCallback, useRef, useState } from "react";
import {
  Button,
  Card,
  Col,
  Drawer,
  Empty,
  Input,
  Row,
  Spin,
  Tag,
  Tooltip,
  message,
} from "antd";

import { xabAskApi } from "src/api/xabApi";
import VoiceRecorder from "src/components/VoiceRecorder";
import ModuleHeader from "src/components/ModuleHeader";
import {
  KNOWLEDGE_DARK,
  KNOWLEDGE_BANNER_FROM,
  KNOWLEDGE_BANNER_TO,
} from "src/pages/knowledge/theme";

/** Ажилтанд санаа өгөх жишээ асуултууд — хоосон дэлгэц бүү үзүүл. */
const SAMPLES = [
  "өндөрт ажиллахад ямар хамгаалалт хэрэгтэй вэ",
  "гагнуурын ажил хийхэд юу анхаарах вэ",
  "хязгаарлагдмал орчинд ажиллах",
  "хувийн хамгаалах хэрэгсэл олгох журам",
  "ажилтан осолд орвол хэнд мэдэгдэх вэ",
];

/**
 * Асуултад таарсан үгсийг ШАРГАЛААР тодруулна.
 *
 * ⚠ Backend нь HTML биш, БАЙРЛАЛ (`marks`) буцаана. Тиймээс энд
 *   `dangerouslySetInnerHTML` ХЭРЭГЛЭХГҮЙ — журмын текст дотор `<`, `&`
 *   зэрэг тэмдэгт байвал ч аюулгүй, зүгээр л текст хэвээр гарна.
 */
function Marked({ text, marks }) {
  if (!text) return null;
  if (!marks || !marks.length) return <>{text}</>;
  const out = [];
  let pos = 0;
  marks.forEach(([s, e], i) => {
    // Хамгаалалт: заагч гажсан бол алгасна (текст хэзээ ч алдагдахгүй)
    if (s < pos || e > text.length || e <= s) return;
    if (s > pos) out.push(text.slice(pos, s));
    out.push(
      <mark
        key={i}
        style={{ background: "#FEF08A", padding: "0 1px", borderRadius: 2 }}
      >
        {text.slice(s, e)}
      </mark>,
    );
    pos = e;
  });
  if (pos < text.length) out.push(text.slice(pos));
  return <>{out}</>;
}

function Hit({ item, color, onOpen, source, isTop }) {
  return (
    <div
      onClick={onOpen}
      title="Дэлгэрэнгүй унших"
      style={{
        padding: "9px 0",
        borderBottom: "1px solid #F2F4F7",
        display: "flex",
        gap: 10,
        alignItems: "flex-start",
        cursor: "pointer",
      }}
    >
      {item.code ? (
        <Tag
          color={color}
          style={{
            marginRight: 0,
            fontFamily: "monospace",
            fontSize: 11,
            flexShrink: 0,
          }}
        >
          {item.code}
        </Tag>
      ) : null}
      <div style={{ flex: 1, minWidth: 0 }}>
        {item.title ? (
          <div style={{ fontWeight: 600, fontSize: 13.5, color: "#1F2430" }}>
            <Marked text={item.title} marks={item.title_marks} />
          </div>
        ) : null}
        {item.text ? (
          <div
            style={{
              fontSize: 12.5,
              color: "#5B6472",
              lineHeight: 1.55,
              marginTop: item.title ? 2 : 0,
            }}
          >
            <Marked text={item.text} marks={item.marks} />
          </div>
        ) : null}
        <div style={{ marginTop: 3, display: "flex", gap: 8, flexWrap: "wrap" }}>
          {item.source ? (
            <span style={{ fontSize: 11, color: "#9AA3B0" }}>{item.source}</span>
          ) : null}
          {/* Эх баримт хавсрагдсан мөрийг ЖАГСААЛТААС ШУУД ялгана —
              ажилтан аль мөрийг нээвэл бүтэн PDF уншиж болохыг
              дарахаасаа өмнө мэдэх ёстой. */}
          {item.has_file ? (
            <Tooltip title="Эх баримт хавсрагдсан — дарж нээнэ">
              <span style={{ fontSize: 11, color: "#DC2626", fontWeight: 600 }}>
                <i className="fas fa-paperclip" style={{ marginRight: 4 }} />
                эх баримттай
              </span>
            </Tooltip>
          ) : null}
          {/* ⚠ Агуулгагүй заавар нь ЗӨВХӨН нэртэй. Үүнийг нуувал ажилтан
              «бүх зүйл системд бий» гэж ойлгож, бодит зааврыг уншихгүй
              өнгөрөх эрсдэлтэй. */}
          {item.has_content === false ? (
            <Tooltip title="Энэ зааврын бичвэр систем дотор одоогоор алга — эх баримтыг ХАБЭА-аас авна">
              <span style={{ fontSize: 11, color: "#D97706" }}>
                <i
                  className="fas fa-exclamation-triangle"
                  style={{ marginRight: 4 }}
                />
                агуулга хавсрагдаагүй
              </span>
            </Tooltip>
          ) : null}
        </div>
      </div>
      {/* ⚠ «Сонсох» нь ХАМГИЙН ИХ ТААРСАН мөрөнд л гарна. Мөр бүрд
          тавибал ажилтан алийг нь сонсохоо мэдэхгүй, бас Chimege рүү
          хэрэггүй дуудлага олширно. */}
      {isTop ? (
        <span
          onClick={(e) => e.stopPropagation()}
          style={{ flexShrink: 0, textAlign: "center" }}
        >
          <SpeakButton source={source} id={item.id} size="small" />
          <div style={{ fontSize: 10, color: "#16A34A", marginTop: 2 }}>
            хамгийн тохирох
          </div>
        </span>
      ) : null}
      {/* Дарж дэлгэрэнгүй унших боломжтойг ил заана — эс бөгөөс мөр нь
          зүгээр текст мэт харагдаж, ажилтан дарж үзэхгүй өнгөрнө. */}
      <i
        className="fas fa-chevron-right"
        style={{ color: "#C4C9D1", fontSize: 11, marginTop: 4 }}
      />
    </div>
  );
}

/**
 * Мөрийн ДЭЛГЭРЭНГҮЙ — бүтэн текст ба эх файл.
 *
 * ⚠ Эх файл ихэнхдээ ХАВСРАГДААГҮЙ (журмын 17-оос 1, зааврын 150-аас 1).
 *   Товчийг байхгүй үед нуухгүй, «хавсрагдаагүй» гэж ИЛ хэлнэ — ажилтан
 *   хайсаар байхаас өөр аргагүйг мэдэх ёстой.
 */
/**
 * «Сонсох» товч — бичвэрийг Chimege-ээр яриа болгож тоглуулна.
 *
 * ЯАГААД: талбар дээрх ажилтан бээлийтэй, гараа бохирдсон, харанхуй
 * газар байж болно. Асуултаа дуугаар асууж, хариугаа СОНСОХ нь
 * гинжийг бүтнээр хаана.
 *
 * ⚠ Chimege-ийн ЯРИА НИЙЛЭГЖҮҮЛЭХ токен нь STT-ийнхээс ТУСДАА. Токен
 *   аваагүй бол backend 502 буцаана — товчийг нуухгүй, шалтгааныг
 *   ойлгомжтой хэлнэ (эс бөгөөс «яагаад ажиллахгүй байна» гэж
 *   эргэлзэнэ).
 */
function SpeakButton({ source, id, size }) {
  const [busy, setBusy] = useState(false);
  const audioRef = useRef(null);

  const play = async () => {
    if (busy) return;
    setBusy(true);
    try {
      const blob = await xabAskApi.askSpeak({ source, id });
      const url = URL.createObjectURL(blob);
      if (audioRef.current) {
        audioRef.current.pause();
        URL.revokeObjectURL(audioRef.current.src);
      }
      const a = new Audio(url);
      audioRef.current = a;
      // Санах ой чөлөөлнө — олон удаа сонсоход хуримтлагдахаас сэргийлнэ
      a.onended = () => URL.revokeObjectURL(url);
      await a.play();
    } catch (e) {
      // Blob хэлбэрийн алдааны биеийг текст болгож уншина
      let msg = "Сонсгож чадсангүй";
      try {
        const t = await e?.response?.data?.text?.();
        const j = t ? JSON.parse(t) : null;
        if (j?.message) msg = j.message;
      } catch (_) {
        /* хариу нь JSON биш байж болно */
      }
      message.warning(msg);
    } finally {
      setBusy(false);
    }
  };

  return (
    <Button size={size} loading={busy} onClick={play}>
      <i className="fas fa-volume-up" style={{ marginRight: 6 }} />
      Сонсох
    </Button>
  );
}

function DetailDrawer({ open, item, query, onClose }) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);

  React.useEffect(() => {
    if (!open || !item) return;
    setLoading(true);
    setData(null);
    xabAskApi
      .askItem({ source: item.source, id: item.id, q: query })
      .then(setData)
      .catch((e) =>
        message.error(e?.response?.data?.message || "Уншиж чадсангүй"),
      )
      .finally(() => setLoading(false));
  }, [open, item, query]);

  return (
    <Drawer
      open={open}
      onClose={onClose}
      width={720}
      title={
        <div style={{ paddingRight: 24 }}>
          <div style={{ fontSize: 14, fontWeight: 700 }}>
            {data?.code || item?.code || "Дэлгэрэнгүй"}
          </div>
          {data?.reg_name ? (
            <div style={{ fontSize: 11.5, color: "#8A94A6", fontWeight: 400 }}>
              {data.reg_name}
            </div>
          ) : null}
        </div>
      }
    >
      {loading ? (
        <div style={{ textAlign: "center", padding: 40 }}>
          <Spin />
        </div>
      ) : data ? (
        <>
          {data.title ? (
            <div style={{ fontWeight: 700, fontSize: 15, marginBottom: 8 }}>
              {data.title}
            </div>
          ) : null}
          {/* ⚠ ХАБ заавар, технологийн картын бичвэр бараг бүгд ХООСОН
              (150-аас ~0). Хоосон цонх нээгдвэл ажилтан «эвдэрсэн юм болов
              уу» гэж эргэлзэнэ — шалтгааныг нь ил хэлнэ. */}
          {(data.text || "").trim() ? (
            <div
              style={{
                whiteSpace: "pre-wrap",
                fontSize: 13.5,
                lineHeight: 1.75,
                color: "#1F2430",
              }}
            >
              <Marked text={data.text} marks={data.marks} />
            </div>
          ) : (
            <Empty
              image={Empty.PRESENTED_IMAGE_SIMPLE}
              description={
                <span style={{ fontSize: 12.5 }}>
                  Энэ баримтын <b>бичвэр систем дотор одоогоор алга</b> —
                  зөвхөн нэр, дугаар нь бүртгэгдсэн.
                  <br />
                  <span style={{ color: "#9AA3B0" }}>
                    Эх баримтыг ХАБЭА хэлтсээс авна уу.
                  </span>
                </span>
              }
            />
          )}

          <div
            style={{
              marginTop: 18,
              paddingTop: 12,
              borderTop: "1px solid #EDEFF3",
              display: "flex",
              gap: 8,
              alignItems: "center",
              flexWrap: "wrap",
            }}
          >
            {/* ⚠ `href` ХЭРЭГЛЭХГҮЙ. antd нь `href`-тэй Button-ыг `<a>`
                болгож зурдаг бөгөөд `type="primary"`-ийн цагаан текст
                алдагдаж, хар дэвсгэр дээр хар үсэг болж уншигдахаа
                болино. `onClick` нь ижил үйлдэл хийгээд загварыг хэвээр
                үлдээнэ. */}
            {data.file_url ? (
              <Button
                type="primary"
                onClick={() =>
                  window.open(data.file_url, "_blank", "noopener,noreferrer")
                }
                icon={<i className="fas fa-file-pdf" style={{ marginRight: 6 }} />}
              >
                Эх баримт нээх
              </Button>
            ) : (
              <span style={{ fontSize: 12, color: "#D97706" }}>
                <i
                  className="fas fa-exclamation-triangle"
                  style={{ marginRight: 6 }}
                />
                Эх файл хавсрагдаагүй — ХАБЭА хэлтсээс лавлана уу
              </span>
            )}
            {(data.text || "").trim() ? (
              <SpeakButton source={data.source} id={data.id} />
            ) : null}
            <Button
              onClick={() => {
                const t = [data.code, data.title, data.text]
                  .filter(Boolean)
                  .join("\n");
                navigator.clipboard?.writeText(t);
                message.success("Хуулагдлаа");
              }}
              icon={<i className="fas fa-copy" style={{ marginRight: 6 }} />}
            >
              Кодтой нь хуулах
            </Button>
            {data.page_no ? (
              <Tag>эх бичгийн {data.page_no}-р хуудас</Tag>
            ) : null}
          </div>
        </>
      ) : null}
    </Drawer>
  );
}

/**
 * @param {boolean} embedded — ӨӨР ХУУДАСТ шигтгэх үед `true`.
 *
 * ⚠ ЯАГААД ПРОП ХЭРЭГТЭЙ ВЭ (2026-10-29, хэрэглэгч: «вэб дээр журмаас
 *   асуух хэсгийг /me дотор хий»): энэ нь БҮТЭН ХУУДАС бөгөөд дээрээ
 *   `ModuleHeader` (өнгөт баннер) зурдаг. /me-ийн таб дотор түүнийг
 *   дахин зурвал хуудсанд ХОЁР баннер болж, агуулга доош түлхэгдэнэ.
 * ⚠ Кодыг ХУВИЛААГҮЙ: хайлт, дуу хоолой, үнэлгээ, дэлгэрэнгүй цонх
 *   бүгд нэг эх сурвалжтай хэвээр — хоёр газар засах шаардлагагүй.
 */
export default function KnowledgeAsk({ embedded = false }) {
  const [q, setQ] = useState("");
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  // Дарж нээсэн мөр — дэлгэрэнгүй цонхонд бүтэн текст татагдана
  const [openItem, setOpenItem] = useState(null);
  // Үнэлгээ өгсөн эсэх — хайлт бүрд шинэчлэгдэнэ
  const [rated, setRated] = useState(false);
  // Дараалсан хүсэлт — хожуу ирсэн хуучин хариу шинийг дарахаас сэргийлнэ
  const seqRef = useRef(0);
  // `rate` нь хамгийн сүүлийн хариултын log_id-г уншина
  const dataRef = useRef(null);

  const run = useCallback((text) => {
    const query = String(text || "").trim();
    if (query.length < 2) return;
    const my = ++seqRef.current;
    setLoading(true);
    setRated(false);
    xabAskApi
      .ask({ q: query, per: 5 })
      .then((d) => {
        if (my === seqRef.current) {
          dataRef.current = d;
          setData(d);
        }
      })
      .catch((e) =>
        message.error(e?.response?.data?.message || "Хайж чадсангүй"),
      )
      .finally(() => {
        if (my === seqRef.current) setLoading(false);
      });
  }, []);

  /** Сэтгэл ханамж. Амжилтгүй болбол ажилтанд алдаа заахгүй — үнэлгээ
   *  нь нэмэлт зүйл, ажлыг нь тасалдуулах ёсгүй. */
  const rate = useCallback((value) => {
    const id = dataRef.current?.log_id;
    if (!id) return;
    setRated(true);
    xabAskApi.askFeedback({ log_id: id, rating: value }).catch(() => {});
  }, []);

  /** Дуу хоолой танигдмагц ШУУД хайна — ажилтан дахин товч дарах шаардлагагүй */
  const onTranscript = useCallback(
    (text) => {
      const t = String(text || "").trim();
      if (!t) return message.warning("Юу ч танигдсангүй. Дахин оролдоно уу.");
      setQ(t);
      run(t);
    },
    [run],
  );

  // ⚠ ХАМГИЙН ТОХИРОХЫГ КЛИЕНТ ТААМАГЛАХГҮЙ. `score` нь индекс тус
  //   бүрдээ тооцогддог тул бүлэг хооронд харьцуулшгүй — үүгээр сонгоход
  //   сул мөр «хамгийн тохирох» болж гардаг байв. Backend нь асуултын
  //   ХАМРАХ ХҮРЭЭгээр (бүх эх сурвалжид ижил утгатай) сонгож `best`
  //   талбараар буцаана.
  const topHit = data?.best || null;

  return (
    <div style={{ padding: embedded ? 0 : 16 }}>
      {embedded ? null : (
        <ModuleHeader
          from={KNOWLEDGE_BANNER_FROM}
          to={KNOWLEDGE_BANNER_TO}
          icon="fa-comments"
          title="Асуух — дүрэм журам, заавар"
          subtitle="Энгийн үгээр бичих эсвэл ярих · холбогдох заалтыг олж өгнө"
        />
      )}

      <Card bodyStyle={{ padding: 14 }} style={{ borderRadius: 12 }}>
        <div style={{ display: "flex", gap: 10, alignItems: "flex-start" }}>
          <Input.Search
            value={q}
            onChange={(e) => setQ(e.target.value)}
            onSearch={run}
            enterButton="Хайх"
            size="large"
            allowClear
            placeholder="Жишээ: өндөрт ажиллахад ямар хамгаалалт хэрэгтэй вэ"
          />
          <div style={{ flexShrink: 0 }}>
            <VoiceRecorder onTranscript={onTranscript} disabled={loading} />
          </div>
        </div>

        {!data && !loading ? (
          <div style={{ marginTop: 12 }}>
            <div style={{ fontSize: 12, color: "#9AA3B0", marginBottom: 6 }}>
              Жишээ асуултууд:
            </div>
            <div style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>
              {SAMPLES.map((s) => (
                <Tag
                  key={s}
                  style={{ cursor: "pointer", fontSize: 12, padding: "3px 8px" }}
                  onClick={() => {
                    setQ(s);
                    run(s);
                  }}
                >
                  {s}
                </Tag>
              ))}
            </div>
          </div>
        ) : null}
      </Card>

      {loading ? (
        <div style={{ padding: 40, textAlign: "center" }}>
          {/* Эхний хайлт удаан — индекс байгуулагдана. Шалтгааныг хэлж өгнө,
              эс бөгөөс хэрэглэгч гацсан гэж бодно. */}
          <Spin size="large" tip="Хайж байна… (анхны хайлт удаан байж болно)" />
        </div>
      ) : null}

      {!loading && data ? (
        data.total ? (
          <>
            <div
              style={{
                margin: "14px 2px 8px",
                fontSize: 12.5,
                color: "#8A94A6",
              }}
            >
              «<b style={{ color: KNOWLEDGE_DARK }}>{data.query}</b>» асуултад{" "}
              <b>{data.total}</b> холбогдож болзошгүй мөр олдлоо
            </div>

            {/* ⚠ Өргөн дэлгэц дээр хоёр багана — журмын заалт нь ихэвчлэн
                урт, бусад эх сурвалж богино тул нэг баганаар өрвөл баруун
                тал хоосон үлдэж, ажилтан доош олон гүйлгэнэ. */}
            <Row gutter={[10, 10]} align="top">
              {data.groups.map((g) => (
                <Col
                  key={g.key}
                  xs={24}
                  xl={g.key === "clause" ? 24 : 12}
                  xxl={g.key === "clause" ? 24 : 8}
                >
                  <Card
                    size="small"
                    style={{ borderRadius: 10, height: "100%" }}
                    bodyStyle={{ padding: "6px 14px 10px" }}
                    title={
                      <span style={{ fontSize: 13 }}>
                        <i
                          className={`fas ${g.icon}`}
                          style={{ marginRight: 8, color: g.color }}
                        />
                        {g.label}
                        <Tag style={{ marginLeft: 8 }}>{g.count}</Tag>
                      </span>
                    }
                  >
                    {g.items.map((it) => (
                      <Hit
                        key={`${g.key}-${it.id}`}
                        item={it}
                        color={g.color}
                        source={g.key}
                        isTop={
                          topHit &&
                          topHit.source === g.key &&
                          topHit.id === it.id
                        }
                        onOpen={() => setOpenItem({ ...it, source: g.key })}
                      />
                    ))}
                  </Card>
                </Col>
              ))}
            </Row>

            {/* Сэтгэл ханамж — энэ нь ХАБЭА-д «хайлт ажиллаж байна уу»
                гэдгийг хэлэх цорын ганц шууд дохио. Лог бичигдээгүй бол
                (хүснэгт үүсээгүй) товч гарахгүй. */}
            {data.log_id ? (
              <div
                style={{
                  marginTop: 10,
                  padding: "10px 12px",
                  background: "#F8FAFC",
                  border: "1px solid #E6E9EF",
                  borderRadius: 8,
                  display: "flex",
                  alignItems: "center",
                  gap: 10,
                  flexWrap: "wrap",
                }}
              >
                <span style={{ fontSize: 12.5, color: "#5B6472" }}>
                  Энэ хариулт тус болов уу?
                </span>
                {rated ? (
                  <span style={{ fontSize: 12.5, color: "#16A34A" }}>
                    <i className="fas fa-check" style={{ marginRight: 5 }} />
                    Баярлалаа
                  </span>
                ) : (
                  <>
                    <Button size="small" onClick={() => rate(1)}>
                      <i
                        className="fas fa-thumbs-up"
                        style={{ marginRight: 6, color: "#16A34A" }}
                      />
                      Тийм
                    </Button>
                    <Button size="small" onClick={() => rate(-1)}>
                      <i
                        className="fas fa-thumbs-down"
                        style={{ marginRight: 6, color: "#DC2626" }}
                      />
                      Үгүй
                    </Button>
                    <span style={{ fontSize: 11, color: "#9AA3B0" }}>
                      «Үгүй» гэвэл ХАБЭА хэлтэс үзэж хариу өгнө
                    </span>
                  </>
                )}
              </div>
            ) : null}

            <div
              style={{
                marginTop: 10,
                padding: "9px 12px",
                background: "#FEF3C7",
                borderLeft: "3px solid #D97706",
                borderRadius: 4,
                fontSize: 12,
                lineHeight: 1.55,
              }}
            >
              Энэ нь <b>хайлтын үр дүн</b> — албан ёсны хариулт биш. Ажлаа
              эхлэхийн өмнө эх заалтыг бүтнээр нь уншиж, эргэлзвэл ХАБЭА-гийн
              ажилтнаас лавлаарай.
            </div>
          </>
        ) : (
          <Card style={{ marginTop: 14, borderRadius: 10 }}>
            {/* ⚠ «Олдсонгүй»-г ХОЁР янзаар ялгаж хэлнэ. Нэг мессежээр
                хэлбэл ажилтан «систем ажиллахгүй байна» гэж буруу
                дүгнэнэ — үнэндээ асуулт нь өөр салбарынх байж болно. */}
            <Empty
              description={
                data.off_topic ? (
                  <span>
                    «{data.query}» — энэ асуулт <b>ХАБЭА-гийн дүрэм журмын
                    хүрээнд</b> алга байна.
                    <br />
                    <span style={{ fontSize: 12, color: "#9AA3B0" }}>
                      Энэ хайлт нь зөвхөн хөдөлмөрийн аюулгүй байдал, эрүүл
                      ахуйн журам, заавраас хайдаг. Цалин, ээлж, хүний нөөц
                      зэрэг асуултад хариулахгүй.
                    </span>
                  </span>
                ) : (
                  <span>
                    «{data.query}» гэсэн асуултад хангалттай ойр заалт
                    олдсонгүй.
                    <br />
                    <span style={{ fontSize: 12, color: "#9AA3B0" }}>
                      Богино, гол үгээр оролдоно уу — ж: «өндөрт ажиллах».
                      Асуулт тань бүртгэгдсэн тул ХАБЭА хэлтэс нэр томьёог
                      нэмж, дараа удаа олдох болно.
                    </span>
                  </span>
                )
              }
            />
          </Card>
        )
      ) : null}

      <DetailDrawer
        open={!!openItem}
        item={openItem}
        query={data?.query || ""}
        onClose={() => setOpenItem(null)}
      />
    </div>
  );
}
